import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bean"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8.86635 8.93408C7.66108 10.1395 6.04963 10.2628 4.76841 11.1998C3.04412 12.4609 1.84355 14.3994 3.03211 17.243C5.03227 22.0282 12.724 23.1008 17.8786 17.9464C23.388 12.4371 22.0081 5.05043 17.1745 3.10057C14.3212 1.94957 12.3676 3.1621 11.1325 4.83573C10.1958 6.10501 10.0858 7.71451 8.86635 8.93408Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M11.3638 11.3867C12.7307 10.0198 12.7307 7.80377 11.3638 6.43693C11.1192 6.19234 10.8475 5.99151 10.5582 5.83446C10.0733 6.88139 9.7834 8.01793 8.86712 8.93431C7.9752 9.82632 6.86084 10.1258 5.82248 10.6009C5.9779 10.8827 6.1751 11.1477 6.41409 11.3867C7.78093 12.7535 9.99701 12.7535 11.3638 11.3867Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.82186 10.6009C6.86021 10.1258 7.97457 9.82636 8.86649 8.93435C9.78277 8.01797 10.0727 6.88143 10.5576 5.8345M5.82186 10.6009C5.45706 10.7679 5.10165 10.9565 4.76855 11.2001M5.82186 10.6009C5.97727 10.8828 6.17448 11.1477 6.41347 11.3867C7.7803 12.7536 9.99638 12.7536 11.3632 11.3867C12.73 10.0199 12.73 7.80381 11.3632 6.43697C11.1186 6.19238 10.8468 5.99155 10.5576 5.8345M5.82186 10.6009C5.82178 10.6008 5.82171 10.6007 5.82164 10.6005M11.1327 4.836C10.8998 5.15154 10.718 5.48812 10.5576 5.8345M10.5576 5.8345C10.5573 5.83434 10.557 5.83418 10.5567 5.83403M17.8786 17.9464C12.724 23.1009 5.03227 22.0283 3.03211 17.243C1.84355 14.3995 3.04412 12.461 4.76841 11.1999C6.04963 10.2628 7.66108 10.1395 8.86635 8.93414C10.0858 7.71457 10.1958 6.10507 11.1325 4.83579C12.3676 3.16216 14.3212 1.94963 17.1745 3.10063C22.0081 5.05049 23.388 12.4372 17.8786 17.9464Z","strokeWidth":"props.strokeWidth"}}]}]};

const Bean = Vue.extend<IconProps>({
  name: 'BeanIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bean',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Bean;
